import { User } from "@store/types";
import { State } from "@store";
import { useSelector } from "react-redux";

type Data<T> = [T];

export function useUser(): Data<User> {
  const user = useSelector((state: State) => state.user);

  return [user];
}
